import { apiSlice } from "../../../services/api/apiSlice";
import type { IMCPAvailableToolsRes, IMCPSetting, IMCPSettingRes, IMCPToolItem } from "../types/mcpTypes";

export const mcpApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMCPAvailableTools: builder.query<IMCPToolItem[], { characterId: string; server_url: string }>({
            query: ({ characterId, server_url }) => ({
                url: `/character/${characterId}/mcp/available-tools`,
                method: "GET",
                params: { server_url },
            }),
            transformResponse: (response: IMCPAvailableToolsRes) => response.data,
            providesTags: ["MCPSetting"],
        }),
        getMCPSetting: builder.query<IMCPSetting, { characterId: string }>({
            query: ({ characterId }) => ({
                url: `/character/${characterId}/mcp-setting`,
                method: "GET",
            }),
            transformResponse: (response: IMCPSettingRes) => response.data,
            providesTags: ["MCPSetting"],
        }),
        updateMCPSetting: builder.mutation<{ message: string }, { characterId: string; setting: IMCPSetting }>({
            query: ({ characterId, setting }) => ({
                url: `/character/${characterId}/mcp-setting`,
                method: "PUT",
                body: setting,
            }),
            invalidatesTags: ["MCPSetting"],
        }),
    }),
});

export const { useGetMCPAvailableToolsQuery, useGetMCPSettingQuery, useUpdateMCPSettingMutation, useLazyGetMCPAvailableToolsQuery } =
    mcpApiSlice;
